﻿{
  "community": {
    "name": "Community",
    "shortDescription": "Account singolo con attività gratuite",
    "features": [
      "Trova e condividi attività",
      "Archivio cloud illimitato delle attività",
      "Accedi alle attività premium"
    ],
    "price": "Gratis",
    "termName": "Per sempre"
  },
  "personal": {
    "name": "Privato",
    "shortDescription": "Account singolo con attività personalizzate",
    "features": [
      "Crea e modifica attività online",
      "Include playlist privata",
      "Accedi alle attività mentre sei in giro"
    ]
  },
  "professional": {
    "name": "Professionista",
    "shortDescription": "Account singolo con più studenti",
    "features": [
      "Gestisci le assegnazioni degli studenti",
      "Monitora i progressi degli studenti",
      "Collabora con i membri del team"
    ]
  },
  "organization": {
    "name": "Azienda",
    "shortDescription": "Account multipli con più studenti",
    "features": [
      "Gestione istruttori",
      "Creazione di report a livello aziendale",
      "Impostazioni privacy a livello aziendale"
    ],
    "price": "Contattaci",
    "termName": "Termini 1-5 anni"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Anteprima editor desktop",
    "note": "Provalo <1>$t(common:action.free)</1> per 30 giorni!",
    "price": "Gratis",
    "termName": "Prova di 30 giorni",
    "footerNote": "1 installazione"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Editor desktop completo",
    "note": "",
    "termName": "Acquisto una tantum",
    "footerNote": "2 installazioni per utente"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Licenze multiple per aziende",
    "note": "",
    "price": "Contattaci",
    "termName": "Sconti a volume",
    "footerNote": "2 installazioni per utente"
  }
}
